import React, { useMemo } from 'react';
import { useStyles } from '@wix/tpa-settings/react';
import { stylesParams } from '@wix/wix-vod-constants/app-settings';
import { StyleParamType, } from '@wix/tpa-settings';
const keyMap = {
    [StyleParamType.Boolean]: 'booleans',
    [StyleParamType.Font]: 'fonts',
    [StyleParamType.Color]: 'colors',
    [StyleParamType.Number]: 'numbers',
};
export function withStyleParams(Component) {
    return (props) => {
        const styles = useStyles();
        const styleParams = useMemo(() => {
            const params = {
                booleans: {},
                numbers: {},
                fonts: {},
                colors: {},
            };
            for (const param of Object.values(stylesParams)) {
                if (!param.getDefaultValue) {
                    continue;
                }
                const name = param.key;
                const key = keyMap[param.type];
                params[key][name] = styles.get(param);
            }
            return params;
        }, [styles]);
        return React.createElement(Component, { styleParams: styleParams, ...props });
    };
}
//# sourceMappingURL=withStyleParams.js.map